import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='wrapper'>
          <div className='main'>
            <div className='page-content page-500-error d-flex flex-mid bg-white'>
              <div className='kmx-container kmx-container--xs p-h-s'>
                <div className='kmx-grid'>
                  <div className='kmx-grid__inner'>
                    <div className='kmx-grid__cell text-center'>
                      <img className='kmx-img' src='/mycarmax/img/password-reset-link-expired.svg' />
                      <h3 className='kmx-typography--display-3 m-t-m'>500</h3>
                      <p className='kmx-typography--body-2'>
                        Due to technical issues we are unable to process your data privacy rights request at this time. Please try again at
                        a later time or call the CarMax Privacy Rights line at (833) 987-1241.
                      </p>
                      <a className='kmx-button kmx-button--primary kmx-button--full' href='/'>
                        Go to CarMax.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
